import Pikaday from 'pikaday'
import moment from 'moment'

import Helpers from '../Helpers'

const DATE_FORMAT = 'ddd D MMM YY'

class ResultsDates {
    constructor(changeEvent) {
        this.changeEvent = changeEvent

        this.startDateField = document.getElementsByName('startDate')[0]
        this.endDateField = document.getElementsByName('endDate')[0]
        this.daysField = document.getElementsByName('ddlDays')[0]
        this.flexField = document.getElementsByName('flex')[0]
        this.specialOfferButtons = document.getElementsByClassName('results-aside__offers')[0].getElementsByTagName('button')
        this.specialOfferDuration = document.getElementsByName('ddlSODuration')[0]
        this.specialOfferDates = document.getElementsByName('ddlSODates')[0]
        this.listeners()

        this.startDate = null
        this.endDate = null

        this.bindStartPicker()
        this.bindEndPicker()
    }

    listeners() {
        const self = this
        // days changed
        new Helpers(this.daysField).eventListener((e) => {
            self.daysSet()
        }, 'change')

        new Helpers(this.flexField).eventListener((e) => {
            self.changeEvent()
        }, 'change')

        new Helpers(this.specialOfferButtons).eventListener((e) => {
            self.specialOfferChange(e.target)
        })
    }

    bindStartPicker() {
        const self = this

        this.startDate = new Pikaday({
            field: this.startDateField,
            minDate: new Date(),
            maxDate: moment(this.startDateField.getAttribute('data-limit'),'YYYY-MM-DD').toDate(),
            format: DATE_FORMAT,
            firstDay: 1,
            onSelect: () => {
                self.startDateSet()
            }
        })
    }

    bindEndPicker() {
        const self = this
        
        // initialise the end date picker
        this.endDate = new Pikaday({
            field: this.endDateField,
            minDate: new Date(),
            maxDate: moment(this.endDateField.getAttribute('data-limit'), 'YYYY-MM-DD').toDate(),
            format: DATE_FORMAT,
            firstDay: 1,
            onSelect: () => {
                self.endDateSet()
            }
        })
    }
        
    // Utility function to get the days difference between the start and end dates
    getDaysDiff() {
        return moment.duration(this.endDate.getMoment().diff(this.startDate.getMoment())).asDays()
    }

    startDateSet() {
        let days = parseInt(this.daysField.value, 10)
        // TODO: change minDate in end date
        if (days === 0 && this.startDateField.value !== '') {
            this.daysField.value = 7
            days = 7
        }
        if (this.endDate == null) {
            this.bindEndPicker()
        }

        this.endDate.setMinDate(this.startDate.getMoment().add(2, 'days').toDate())
        this.endDate.setDate(this.startDate.getMoment().add(days, 'days').toDate(), true)

        this.changeEvent()
    }

    endDateSet() {
        // get period length betweenselected dates
        const period = this.getDaysDiff()
        // if its less than the duration specified, reduce the days value
        if (period < parseInt(this.daysField.value, 10)) {
            if (period >= 7) {
                this.daysField.value = Math.floor(period / 7) * 7
            } else {
                this.daysField.value = period
            }
        }

        this.changeEvent()
    }


    daysSet() {
        const days = parseInt(this.daysField.value, 10)
        if (days === 0) {
            this.startDate.setDate(null, true)
            this.endDate.setDate(null, true)
        } else if (this.startDate.getDate() != null) {
            const period = this.getDaysDiff()
            if (days > period) {
                this.endDate.setDate(this.startDate.getMoment().add(days, 'days').toDate(), true)
            }
        }

        this.changeEvent()
    }

    specialOfferChange(activeButton) {
        // set classes on buttons to reflect active state
        new Helpers(this.specialOfferButtons).removeClass('results-aside__offers-toggle--active')
        new Helpers(activeButton).addClass('results-aside__offers-toggle--active')

        this.changeEvent()
    }

    setSpecialOffer(value) {
        if (value !== 'Y') {
            value = ''
        }
        // set classes on buttons to reflect active state
        new Helpers(this.specialOfferButtons).removeClass('results-aside__offers-toggle--active')
        new Helpers(Array.from(this.specialOfferButtons).filter(b => b.getAttribute('data-value') === value)).addClass('results-aside__offers-toggle--active')           
    }

    getSpecialOfferValue() {
        const showOffers = document.getElementsByClassName('results-aside__offers-toggle--active')[0].getAttribute('data-value') === 'Y'
        return showOffers ? 'Y' : null
    }

    getValues() {

        const values = {}
        values.oso = this.getSpecialOfferValue()

        values.dss = this.startDate == null || this.startDate.getDate() == null ? null : this.startDate.getMoment().format(DATE_FORMAT)
        values.des = this.endDate == null || this.endDate.getDate() == null ? null : this.endDate.getMoment().format(DATE_FORMAT)
        values.nday = parseInt(this.daysField.value, 10)
        values.flex = parseInt(this.flexField.value, 10)

        return values
    }


    getNonDefaultValues() {
        const values = this.getValues()
        Object.keys(values).forEach((key) => {
            if (key !== 'flex' && (values[key] == null || values[key] === 0)) {
                delete values[key]
            } else if (key === 'flex' && values[key] === parseInt(this.flexField.getAttribute('data-default-value'), 10)) {
                delete values[key]
            }
        })
        return values
    }

    setValues(values) {
        const parsedStartDate = values.dss || null ? moment(values.dss, DATE_FORMAT).toDate() : null
        this.startDate.setDate(parsedStartDate, true)        
        if (this.endDate != null) {
            const parsedEndDate = values.des || null ? moment(values.des, DATE_FORMAT).toDate() : null
            this.endDate.setDate(parsedEndDate, true)
        }
        this.daysField.value = values.nday || 0

        if (typeof values.flex !== 'undefined' && !isNaN(values.flex)) {
            this.flexField.value = values.flex
        } else {
            parseInt(this.flexField.getAttribute('data-default-value'), 10)
        }

        this.setSpecialOffer(values.oso || null)
    }
}

export default ResultsDates